import { ICurrentUserStatus } from '@didomi/react';
import { CurrentUserStatus } from '@didomi/react-native';

import debugLog from 'utils/debugLog.ts';

function createConsentMask(
    consentOrdering: string[] | undefined,
    didomiUserStatus: CurrentUserStatus | ICurrentUserStatus | undefined,
) {
    let mask = '';

    consentOrdering?.forEach((purposeId) => {
        const purpose = didomiUserStatus?.purposes?.[purposeId];

        if (purpose) {
            mask += purpose.enabled ? '1' : '0';
        } else {
            debugLog(
                `Purpose ID "${purposeId}" is missing while building the consentMask. Falling back to 0.`,
            );

            mask += '0';
        }
    });

    return mask === '000' || !mask ? '100' : mask;
}

export default createConsentMask;
